import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  padding?: number;
  className?: string;
}

const CardFrame: React.FC<Props> = ({ children, padding = 4, className = '' }) => (
  <div className={`${className} bg-blur-md bg-opacity-medium border border-border-secondary rounded-3xl p-${padding}`}>
    {children}
  </div>
);

export default CardFrame;
